/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SupportSessionRouteImport } from './routes/support-session'
import { Route as UnauthenticatedRouteImport } from './routes/_unauthenticated'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as R404RouteImport } from './routes/404'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as ShareTokenRouteImport } from './routes/share.$token'
import { Route as UnauthenticatedSignupRouteImport } from './routes/_unauthenticated/signup'
import { Route as UnauthenticatedLoginRouteImport } from './routes/_unauthenticated/login'
import { Route as UnauthenticatedForgotPasswordRouteImport } from './routes/_unauthenticated/forgot-password'
import { Route as UnauthenticatedConfirmSignupRouteImport } from './routes/_unauthenticated/confirm-signup'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedDashRouteImport } from './routes/_authenticated/dash'
import { Route as AuthenticatedOrgsRouteRouteImport } from './routes/_authenticated/orgs/route'
import { Route as AuthenticatedOrgsIndexRouteImport } from './routes/_authenticated/orgs/index'
import { Route as AuthenticatedBillingCheckoutReturnRouteImport } from './routes/_authenticated/billing/checkout-return'
import { Route as AuthenticatedOrgsOrgIdRouteRouteImport } from './routes/_authenticated/orgs/$orgId/route'
import { Route as AuthenticatedOrgsOrgIdIndexRouteImport } from './routes/_authenticated/orgs/$orgId/index'
import { Route as AuthenticatedOrgsOrgIdSettingsRouteImport } from './routes/_authenticated/orgs/$orgId/settings'
import { Route as AuthenticatedOrgsOrgIdProjectsRouteImport } from './routes/_authenticated/orgs/$orgId/projects'
import { Route as AuthenticatedOrgsOrgIdPermissionsRouteImport } from './routes/_authenticated/orgs/$orgId/permissions'
import { Route as AuthenticatedOrgsOrgIdMembersRouteImport } from './routes/_authenticated/orgs/$orgId/members'
import { Route as AuthenticatedOrgsOrgIdBillingRouteImport } from './routes/_authenticated/orgs/$orgId/billing'
import { Route as AuthenticatedOrgsOrgIdProjectsRouteRouteImport } from './routes/_authenticated/orgs/$orgId_/projects/route'
import { Route as AuthenticatedOrgsOrgIdGroupsRouteRouteImport } from './routes/_authenticated/orgs/$orgId/groups/route'
import { Route as AuthenticatedOrgsOrgIdGroupsIndexRouteImport } from './routes/_authenticated/orgs/$orgId/groups/index'
import { Route as AuthenticatedOrgsOrgIdGroupsGroupIdRouteImport } from './routes/_authenticated/orgs/$orgId/groups/$groupId'
import { Route as AuthenticatedOrgsOrgIdProjectsProjectIdRouteRouteImport } from './routes/_authenticated/orgs/$orgId_/projects/$projectId/route'
import { Route as AuthenticatedOrgsOrgIdProjectsProjectIdIndexRouteImport } from './routes/_authenticated/orgs/$orgId_/projects/$projectId/index'
import { Route as AuthenticatedOrgsOrgIdProjectsProjectIdTasksRouteImport } from './routes/_authenticated/orgs/$orgId_/projects/$projectId/tasks'
import { Route as AuthenticatedOrgsOrgIdProjectsProjectIdPermissionsRouteImport } from './routes/_authenticated/orgs/$orgId_/projects/$projectId/permissions'
import { Route as AuthenticatedOrgsOrgIdProjectsProjectIdIntegrationsRouteImport } from './routes/_authenticated/orgs/$orgId_/projects/$projectId/integrations'
import { Route as AuthenticatedOrgsOrgIdProjectsProjectIdAssetSetsRouteImport } from './routes/_authenticated/orgs/$orgId_/projects/$projectId/asset-sets'
import { Route as AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRouteImport } from './routes/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/route'
import { Route as AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareRouteImport } from './routes/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/compare'
import { Route as AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksTasksRouteImport } from './routes/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/tasks/tasks'
import { Route as AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksCreateRouteImport } from './routes/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/tasks/create'
import { Route as AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareCompareTypeRouteImport } from './routes/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/compare_.$compareType'
import { Route as AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsCreateRouteImport } from './routes/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/create'
import { Route as AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdRouteImport } from './routes/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId'
import { Route as AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdModelRouteImport } from './routes/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_.model'
import { Route as AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdMapAdvancedRouteImport } from './routes/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_.map-advanced'
import { Route as AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAnnotateRouteImport } from './routes/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_.annotate'
import { Route as AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAssetsAssetIdMapRouteImport } from './routes/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_.assets_.$assetId_.map'

const SupportSessionRoute = SupportSessionRouteImport.update({
  id: '/support-session',
  path: '/support-session',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedRoute = UnauthenticatedRouteImport.update({
  id: '/_unauthenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const ShareTokenRoute = ShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedSignupRoute = UnauthenticatedSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => UnauthenticatedRoute,
} as any)
const UnauthenticatedLoginRoute = UnauthenticatedLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => UnauthenticatedRoute,
} as any)
const UnauthenticatedForgotPasswordRoute =
  UnauthenticatedForgotPasswordRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedConfirmSignupRoute =
  UnauthenticatedConfirmSignupRouteImport.update({
    id: '/confirm-signup',
    path: '/confirm-signup',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashRoute = AuthenticatedDashRouteImport.update({
  id: '/dash',
  path: '/dash',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrgsRouteRoute = AuthenticatedOrgsRouteRouteImport.update({
  id: '/orgs',
  path: '/orgs',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrgsIndexRoute = AuthenticatedOrgsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedOrgsRouteRoute,
} as any)
const AuthenticatedBillingCheckoutReturnRoute =
  AuthenticatedBillingCheckoutReturnRouteImport.update({
    id: '/billing/checkout-return',
    path: '/billing/checkout-return',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrgsOrgIdRouteRoute =
  AuthenticatedOrgsOrgIdRouteRouteImport.update({
    id: '/$orgId',
    path: '/$orgId',
    getParentRoute: () => AuthenticatedOrgsRouteRoute,
  } as any)
const AuthenticatedOrgsOrgIdIndexRoute =
  AuthenticatedOrgsOrgIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgsOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgsOrgIdSettingsRoute =
  AuthenticatedOrgsOrgIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedOrgsOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgsOrgIdProjectsRoute =
  AuthenticatedOrgsOrgIdProjectsRouteImport.update({
    id: '/projects',
    path: '/projects',
    getParentRoute: () => AuthenticatedOrgsOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgsOrgIdPermissionsRoute =
  AuthenticatedOrgsOrgIdPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => AuthenticatedOrgsOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgsOrgIdMembersRoute =
  AuthenticatedOrgsOrgIdMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthenticatedOrgsOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgsOrgIdBillingRoute =
  AuthenticatedOrgsOrgIdBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedOrgsOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgsOrgIdProjectsRouteRoute =
  AuthenticatedOrgsOrgIdProjectsRouteRouteImport.update({
    id: '/$orgId_/projects',
    path: '/$orgId/projects',
    getParentRoute: () => AuthenticatedOrgsRouteRoute,
  } as any)
const AuthenticatedOrgsOrgIdGroupsRouteRoute =
  AuthenticatedOrgsOrgIdGroupsRouteRouteImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => AuthenticatedOrgsOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgsOrgIdGroupsIndexRoute =
  AuthenticatedOrgsOrgIdGroupsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgsOrgIdGroupsRouteRoute,
  } as any)
const AuthenticatedOrgsOrgIdGroupsGroupIdRoute =
  AuthenticatedOrgsOrgIdGroupsGroupIdRouteImport.update({
    id: '/$groupId',
    path: '/$groupId',
    getParentRoute: () => AuthenticatedOrgsOrgIdGroupsRouteRoute,
  } as any)
const AuthenticatedOrgsOrgIdProjectsProjectIdRouteRoute =
  AuthenticatedOrgsOrgIdProjectsProjectIdRouteRouteImport.update({
    id: '/$projectId',
    path: '/$projectId',
    getParentRoute: () => AuthenticatedOrgsOrgIdProjectsRouteRoute,
  } as any)
const AuthenticatedOrgsOrgIdProjectsProjectIdIndexRoute =
  AuthenticatedOrgsOrgIdProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgsOrgIdProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedOrgsOrgIdProjectsProjectIdTasksRoute =
  AuthenticatedOrgsOrgIdProjectsProjectIdTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => AuthenticatedOrgsOrgIdProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedOrgsOrgIdProjectsProjectIdPermissionsRoute =
  AuthenticatedOrgsOrgIdProjectsProjectIdPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => AuthenticatedOrgsOrgIdProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedOrgsOrgIdProjectsProjectIdIntegrationsRoute =
  AuthenticatedOrgsOrgIdProjectsProjectIdIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedOrgsOrgIdProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedOrgsOrgIdProjectsProjectIdAssetSetsRoute =
  AuthenticatedOrgsOrgIdProjectsProjectIdAssetSetsRouteImport.update({
    id: '/asset-sets',
    path: '/asset-sets',
    getParentRoute: () => AuthenticatedOrgsOrgIdProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute =
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRouteImport.update({
    id: '/$projectId_/_pathless',
    path: '/$projectId',
    getParentRoute: () => AuthenticatedOrgsOrgIdProjectsRouteRoute,
  } as any)
const AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareRoute =
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareRouteImport.update({
    id: '/compare',
    path: '/compare',
    getParentRoute: () =>
      AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute,
  } as any)
const AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksTasksRoute =
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksTasksRouteImport.update({
    id: '/tasks/tasks',
    path: '/tasks/tasks',
    getParentRoute: () =>
      AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute,
  } as any)
const AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksCreateRoute =
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksCreateRouteImport.update(
    {
      id: '/tasks/create',
      path: '/tasks/create',
      getParentRoute: () =>
        AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute,
    } as any,
  )
const AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareCompareTypeRoute =
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareCompareTypeRouteImport.update(
    {
      id: '/compare_/$compareType',
      path: '/compare/$compareType',
      getParentRoute: () =>
        AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute,
    } as any,
  )
const AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsCreateRoute =
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsCreateRouteImport.update(
    {
      id: '/asset-sets/create',
      path: '/asset-sets/create',
      getParentRoute: () =>
        AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute,
    } as any,
  )
const AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdRoute =
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdRouteImport.update(
    {
      id: '/asset-sets/$assetSetId',
      path: '/asset-sets/$assetSetId',
      getParentRoute: () =>
        AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute,
    } as any,
  )
const AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdModelRoute =
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdModelRouteImport.update(
    {
      id: '/asset-sets/$assetSetId_/model',
      path: '/asset-sets/$assetSetId/model',
      getParentRoute: () =>
        AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute,
    } as any,
  )
const AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdMapAdvancedRoute =
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdMapAdvancedRouteImport.update(
    {
      id: '/asset-sets/$assetSetId_/map-advanced',
      path: '/asset-sets/$assetSetId/map-advanced',
      getParentRoute: () =>
        AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute,
    } as any,
  )
const AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAnnotateRoute =
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAnnotateRouteImport.update(
    {
      id: '/asset-sets/$assetSetId_/annotate',
      path: '/asset-sets/$assetSetId/annotate',
      getParentRoute: () =>
        AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute,
    } as any,
  )
const AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAssetsAssetIdMapRoute =
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAssetsAssetIdMapRouteImport.update(
    {
      id: '/asset-sets/$assetSetId_/assets_/$assetId_/map',
      path: '/asset-sets/$assetSetId/assets/$assetId/map',
      getParentRoute: () =>
        AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/$': typeof SplatRoute
  '/404': typeof R404Route
  '/': typeof AuthenticatedIndexRoute
  '/support-session': typeof SupportSessionRoute
  '/orgs': typeof AuthenticatedOrgsRouteRouteWithChildren
  '/dash': typeof AuthenticatedDashRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/confirm-signup': typeof UnauthenticatedConfirmSignupRoute
  '/forgot-password': typeof UnauthenticatedForgotPasswordRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/signup': typeof UnauthenticatedSignupRoute
  '/share/$token': typeof ShareTokenRoute
  '/orgs/$orgId': typeof AuthenticatedOrgsOrgIdRouteRouteWithChildren
  '/billing/checkout-return': typeof AuthenticatedBillingCheckoutReturnRoute
  '/orgs/': typeof AuthenticatedOrgsIndexRoute
  '/orgs/$orgId/groups': typeof AuthenticatedOrgsOrgIdGroupsRouteRouteWithChildren
  '/orgs/$orgId/projects': typeof AuthenticatedOrgsOrgIdProjectsRoute
  '/orgs/$orgId/billing': typeof AuthenticatedOrgsOrgIdBillingRoute
  '/orgs/$orgId/members': typeof AuthenticatedOrgsOrgIdMembersRoute
  '/orgs/$orgId/permissions': typeof AuthenticatedOrgsOrgIdPermissionsRoute
  '/orgs/$orgId/settings': typeof AuthenticatedOrgsOrgIdSettingsRoute
  '/orgs/$orgId/': typeof AuthenticatedOrgsOrgIdIndexRoute
  '/orgs/$orgId/projects/$projectId': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRouteWithChildren
  '/orgs/$orgId/groups/$groupId': typeof AuthenticatedOrgsOrgIdGroupsGroupIdRoute
  '/orgs/$orgId/groups/': typeof AuthenticatedOrgsOrgIdGroupsIndexRoute
  '/orgs/$orgId/projects/$projectId/asset-sets': typeof AuthenticatedOrgsOrgIdProjectsProjectIdAssetSetsRoute
  '/orgs/$orgId/projects/$projectId/integrations': typeof AuthenticatedOrgsOrgIdProjectsProjectIdIntegrationsRoute
  '/orgs/$orgId/projects/$projectId/permissions': typeof AuthenticatedOrgsOrgIdProjectsProjectIdPermissionsRoute
  '/orgs/$orgId/projects/$projectId/tasks': typeof AuthenticatedOrgsOrgIdProjectsProjectIdTasksRoute
  '/orgs/$orgId/projects/$projectId/': typeof AuthenticatedOrgsOrgIdProjectsProjectIdIndexRoute
  '/orgs/$orgId/projects/$projectId/compare': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareRoute
  '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdRoute
  '/orgs/$orgId/projects/$projectId/asset-sets/create': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsCreateRoute
  '/orgs/$orgId/projects/$projectId/compare/$compareType': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareCompareTypeRoute
  '/orgs/$orgId/projects/$projectId/tasks/create': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksCreateRoute
  '/orgs/$orgId/projects/$projectId/tasks/tasks': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksTasksRoute
  '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/annotate': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAnnotateRoute
  '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/map-advanced': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdMapAdvancedRoute
  '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/model': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdModelRoute
  '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/assets/$assetId/map': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAssetsAssetIdMapRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/404': typeof R404Route
  '/': typeof AuthenticatedIndexRoute
  '/support-session': typeof SupportSessionRoute
  '/dash': typeof AuthenticatedDashRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/confirm-signup': typeof UnauthenticatedConfirmSignupRoute
  '/forgot-password': typeof UnauthenticatedForgotPasswordRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/signup': typeof UnauthenticatedSignupRoute
  '/share/$token': typeof ShareTokenRoute
  '/billing/checkout-return': typeof AuthenticatedBillingCheckoutReturnRoute
  '/orgs': typeof AuthenticatedOrgsIndexRoute
  '/orgs/$orgId/projects': typeof AuthenticatedOrgsOrgIdProjectsRoute
  '/orgs/$orgId/billing': typeof AuthenticatedOrgsOrgIdBillingRoute
  '/orgs/$orgId/members': typeof AuthenticatedOrgsOrgIdMembersRoute
  '/orgs/$orgId/permissions': typeof AuthenticatedOrgsOrgIdPermissionsRoute
  '/orgs/$orgId/settings': typeof AuthenticatedOrgsOrgIdSettingsRoute
  '/orgs/$orgId': typeof AuthenticatedOrgsOrgIdIndexRoute
  '/orgs/$orgId/groups/$groupId': typeof AuthenticatedOrgsOrgIdGroupsGroupIdRoute
  '/orgs/$orgId/groups': typeof AuthenticatedOrgsOrgIdGroupsIndexRoute
  '/orgs/$orgId/projects/$projectId': typeof AuthenticatedOrgsOrgIdProjectsProjectIdIndexRoute
  '/orgs/$orgId/projects/$projectId/asset-sets': typeof AuthenticatedOrgsOrgIdProjectsProjectIdAssetSetsRoute
  '/orgs/$orgId/projects/$projectId/integrations': typeof AuthenticatedOrgsOrgIdProjectsProjectIdIntegrationsRoute
  '/orgs/$orgId/projects/$projectId/permissions': typeof AuthenticatedOrgsOrgIdProjectsProjectIdPermissionsRoute
  '/orgs/$orgId/projects/$projectId/tasks': typeof AuthenticatedOrgsOrgIdProjectsProjectIdTasksRoute
  '/orgs/$orgId/projects/$projectId/compare': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareRoute
  '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdRoute
  '/orgs/$orgId/projects/$projectId/asset-sets/create': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsCreateRoute
  '/orgs/$orgId/projects/$projectId/compare/$compareType': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareCompareTypeRoute
  '/orgs/$orgId/projects/$projectId/tasks/create': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksCreateRoute
  '/orgs/$orgId/projects/$projectId/tasks/tasks': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksTasksRoute
  '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/annotate': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAnnotateRoute
  '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/map-advanced': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdMapAdvancedRoute
  '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/model': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdModelRoute
  '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/assets/$assetId/map': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAssetsAssetIdMapRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$': typeof SplatRoute
  '/404': typeof R404Route
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_unauthenticated': typeof UnauthenticatedRouteWithChildren
  '/support-session': typeof SupportSessionRoute
  '/_authenticated/orgs': typeof AuthenticatedOrgsRouteRouteWithChildren
  '/_authenticated/dash': typeof AuthenticatedDashRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_unauthenticated/confirm-signup': typeof UnauthenticatedConfirmSignupRoute
  '/_unauthenticated/forgot-password': typeof UnauthenticatedForgotPasswordRoute
  '/_unauthenticated/login': typeof UnauthenticatedLoginRoute
  '/_unauthenticated/signup': typeof UnauthenticatedSignupRoute
  '/share/$token': typeof ShareTokenRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/orgs/$orgId': typeof AuthenticatedOrgsOrgIdRouteRouteWithChildren
  '/_authenticated/billing/checkout-return': typeof AuthenticatedBillingCheckoutReturnRoute
  '/_authenticated/orgs/': typeof AuthenticatedOrgsIndexRoute
  '/_authenticated/orgs/$orgId/groups': typeof AuthenticatedOrgsOrgIdGroupsRouteRouteWithChildren
  '/_authenticated/orgs/$orgId_/projects': typeof AuthenticatedOrgsOrgIdProjectsRouteRouteWithChildren
  '/_authenticated/orgs/$orgId/billing': typeof AuthenticatedOrgsOrgIdBillingRoute
  '/_authenticated/orgs/$orgId/members': typeof AuthenticatedOrgsOrgIdMembersRoute
  '/_authenticated/orgs/$orgId/permissions': typeof AuthenticatedOrgsOrgIdPermissionsRoute
  '/_authenticated/orgs/$orgId/projects': typeof AuthenticatedOrgsOrgIdProjectsRoute
  '/_authenticated/orgs/$orgId/settings': typeof AuthenticatedOrgsOrgIdSettingsRoute
  '/_authenticated/orgs/$orgId/': typeof AuthenticatedOrgsOrgIdIndexRoute
  '/_authenticated/orgs/$orgId_/projects/$projectId': typeof AuthenticatedOrgsOrgIdProjectsProjectIdRouteRouteWithChildren
  '/_authenticated/orgs/$orgId/groups/$groupId': typeof AuthenticatedOrgsOrgIdGroupsGroupIdRoute
  '/_authenticated/orgs/$orgId/groups/': typeof AuthenticatedOrgsOrgIdGroupsIndexRoute
  '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRouteWithChildren
  '/_authenticated/orgs/$orgId_/projects/$projectId/asset-sets': typeof AuthenticatedOrgsOrgIdProjectsProjectIdAssetSetsRoute
  '/_authenticated/orgs/$orgId_/projects/$projectId/integrations': typeof AuthenticatedOrgsOrgIdProjectsProjectIdIntegrationsRoute
  '/_authenticated/orgs/$orgId_/projects/$projectId/permissions': typeof AuthenticatedOrgsOrgIdProjectsProjectIdPermissionsRoute
  '/_authenticated/orgs/$orgId_/projects/$projectId/tasks': typeof AuthenticatedOrgsOrgIdProjectsProjectIdTasksRoute
  '/_authenticated/orgs/$orgId_/projects/$projectId/': typeof AuthenticatedOrgsOrgIdProjectsProjectIdIndexRoute
  '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/compare': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareRoute
  '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdRoute
  '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/create': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsCreateRoute
  '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/compare_/$compareType': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareCompareTypeRoute
  '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/tasks/create': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksCreateRoute
  '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/tasks/tasks': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksTasksRoute
  '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_/annotate': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAnnotateRoute
  '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_/map-advanced': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdMapAdvancedRoute
  '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_/model': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdModelRoute
  '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_/assets_/$assetId_/map': typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAssetsAssetIdMapRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$'
    | '/404'
    | '/'
    | '/support-session'
    | '/orgs'
    | '/dash'
    | '/profile'
    | '/confirm-signup'
    | '/forgot-password'
    | '/login'
    | '/signup'
    | '/share/$token'
    | '/orgs/$orgId'
    | '/billing/checkout-return'
    | '/orgs/'
    | '/orgs/$orgId/groups'
    | '/orgs/$orgId/projects'
    | '/orgs/$orgId/billing'
    | '/orgs/$orgId/members'
    | '/orgs/$orgId/permissions'
    | '/orgs/$orgId/settings'
    | '/orgs/$orgId/'
    | '/orgs/$orgId/projects/$projectId'
    | '/orgs/$orgId/groups/$groupId'
    | '/orgs/$orgId/groups/'
    | '/orgs/$orgId/projects/$projectId/asset-sets'
    | '/orgs/$orgId/projects/$projectId/integrations'
    | '/orgs/$orgId/projects/$projectId/permissions'
    | '/orgs/$orgId/projects/$projectId/tasks'
    | '/orgs/$orgId/projects/$projectId/'
    | '/orgs/$orgId/projects/$projectId/compare'
    | '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId'
    | '/orgs/$orgId/projects/$projectId/asset-sets/create'
    | '/orgs/$orgId/projects/$projectId/compare/$compareType'
    | '/orgs/$orgId/projects/$projectId/tasks/create'
    | '/orgs/$orgId/projects/$projectId/tasks/tasks'
    | '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/annotate'
    | '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/map-advanced'
    | '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/model'
    | '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/assets/$assetId/map'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/404'
    | '/'
    | '/support-session'
    | '/dash'
    | '/profile'
    | '/confirm-signup'
    | '/forgot-password'
    | '/login'
    | '/signup'
    | '/share/$token'
    | '/billing/checkout-return'
    | '/orgs'
    | '/orgs/$orgId/projects'
    | '/orgs/$orgId/billing'
    | '/orgs/$orgId/members'
    | '/orgs/$orgId/permissions'
    | '/orgs/$orgId/settings'
    | '/orgs/$orgId'
    | '/orgs/$orgId/groups/$groupId'
    | '/orgs/$orgId/groups'
    | '/orgs/$orgId/projects/$projectId'
    | '/orgs/$orgId/projects/$projectId/asset-sets'
    | '/orgs/$orgId/projects/$projectId/integrations'
    | '/orgs/$orgId/projects/$projectId/permissions'
    | '/orgs/$orgId/projects/$projectId/tasks'
    | '/orgs/$orgId/projects/$projectId/compare'
    | '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId'
    | '/orgs/$orgId/projects/$projectId/asset-sets/create'
    | '/orgs/$orgId/projects/$projectId/compare/$compareType'
    | '/orgs/$orgId/projects/$projectId/tasks/create'
    | '/orgs/$orgId/projects/$projectId/tasks/tasks'
    | '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/annotate'
    | '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/map-advanced'
    | '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/model'
    | '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/assets/$assetId/map'
  id:
    | '__root__'
    | '/$'
    | '/404'
    | '/_authenticated'
    | '/_unauthenticated'
    | '/support-session'
    | '/_authenticated/orgs'
    | '/_authenticated/dash'
    | '/_authenticated/profile'
    | '/_unauthenticated/confirm-signup'
    | '/_unauthenticated/forgot-password'
    | '/_unauthenticated/login'
    | '/_unauthenticated/signup'
    | '/share/$token'
    | '/_authenticated/'
    | '/_authenticated/orgs/$orgId'
    | '/_authenticated/billing/checkout-return'
    | '/_authenticated/orgs/'
    | '/_authenticated/orgs/$orgId/groups'
    | '/_authenticated/orgs/$orgId_/projects'
    | '/_authenticated/orgs/$orgId/billing'
    | '/_authenticated/orgs/$orgId/members'
    | '/_authenticated/orgs/$orgId/permissions'
    | '/_authenticated/orgs/$orgId/projects'
    | '/_authenticated/orgs/$orgId/settings'
    | '/_authenticated/orgs/$orgId/'
    | '/_authenticated/orgs/$orgId_/projects/$projectId'
    | '/_authenticated/orgs/$orgId/groups/$groupId'
    | '/_authenticated/orgs/$orgId/groups/'
    | '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless'
    | '/_authenticated/orgs/$orgId_/projects/$projectId/asset-sets'
    | '/_authenticated/orgs/$orgId_/projects/$projectId/integrations'
    | '/_authenticated/orgs/$orgId_/projects/$projectId/permissions'
    | '/_authenticated/orgs/$orgId_/projects/$projectId/tasks'
    | '/_authenticated/orgs/$orgId_/projects/$projectId/'
    | '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/compare'
    | '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId'
    | '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/create'
    | '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/compare_/$compareType'
    | '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/tasks/create'
    | '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/tasks/tasks'
    | '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_/annotate'
    | '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_/map-advanced'
    | '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_/model'
    | '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_/assets_/$assetId_/map'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SplatRoute: typeof SplatRoute
  R404Route: typeof R404Route
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  UnauthenticatedRoute: typeof UnauthenticatedRouteWithChildren
  SupportSessionRoute: typeof SupportSessionRoute
  ShareTokenRoute: typeof ShareTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/support-session': {
      id: '/support-session'
      path: '/support-session'
      fullPath: '/support-session'
      preLoaderRoute: typeof SupportSessionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated': {
      id: '/_unauthenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof UnauthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/share/$token': {
      id: '/share/$token'
      path: '/share/$token'
      fullPath: '/share/$token'
      preLoaderRoute: typeof ShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated/signup': {
      id: '/_unauthenticated/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof UnauthenticatedSignupRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/login': {
      id: '/_unauthenticated/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthenticatedLoginRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/forgot-password': {
      id: '/_unauthenticated/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof UnauthenticatedForgotPasswordRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/confirm-signup': {
      id: '/_unauthenticated/confirm-signup'
      path: '/confirm-signup'
      fullPath: '/confirm-signup'
      preLoaderRoute: typeof UnauthenticatedConfirmSignupRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dash': {
      id: '/_authenticated/dash'
      path: '/dash'
      fullPath: '/dash'
      preLoaderRoute: typeof AuthenticatedDashRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orgs': {
      id: '/_authenticated/orgs'
      path: '/orgs'
      fullPath: '/orgs'
      preLoaderRoute: typeof AuthenticatedOrgsRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orgs/': {
      id: '/_authenticated/orgs/'
      path: '/'
      fullPath: '/orgs/'
      preLoaderRoute: typeof AuthenticatedOrgsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgsRouteRoute
    }
    '/_authenticated/billing/checkout-return': {
      id: '/_authenticated/billing/checkout-return'
      path: '/billing/checkout-return'
      fullPath: '/billing/checkout-return'
      preLoaderRoute: typeof AuthenticatedBillingCheckoutReturnRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orgs/$orgId': {
      id: '/_authenticated/orgs/$orgId'
      path: '/$orgId'
      fullPath: '/orgs/$orgId'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdRouteRouteImport
      parentRoute: typeof AuthenticatedOrgsRouteRoute
    }
    '/_authenticated/orgs/$orgId/': {
      id: '/_authenticated/orgs/$orgId/'
      path: '/'
      fullPath: '/orgs/$orgId/'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdRouteRoute
    }
    '/_authenticated/orgs/$orgId/settings': {
      id: '/_authenticated/orgs/$orgId/settings'
      path: '/settings'
      fullPath: '/orgs/$orgId/settings'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdSettingsRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdRouteRoute
    }
    '/_authenticated/orgs/$orgId/projects': {
      id: '/_authenticated/orgs/$orgId/projects'
      path: '/projects'
      fullPath: '/orgs/$orgId/projects'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdProjectsRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdRouteRoute
    }
    '/_authenticated/orgs/$orgId/permissions': {
      id: '/_authenticated/orgs/$orgId/permissions'
      path: '/permissions'
      fullPath: '/orgs/$orgId/permissions'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdPermissionsRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdRouteRoute
    }
    '/_authenticated/orgs/$orgId/members': {
      id: '/_authenticated/orgs/$orgId/members'
      path: '/members'
      fullPath: '/orgs/$orgId/members'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdMembersRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdRouteRoute
    }
    '/_authenticated/orgs/$orgId/billing': {
      id: '/_authenticated/orgs/$orgId/billing'
      path: '/billing'
      fullPath: '/orgs/$orgId/billing'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdBillingRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdRouteRoute
    }
    '/_authenticated/orgs/$orgId_/projects': {
      id: '/_authenticated/orgs/$orgId_/projects'
      path: '/$orgId/projects'
      fullPath: '/orgs/$orgId/projects'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdProjectsRouteRouteImport
      parentRoute: typeof AuthenticatedOrgsRouteRoute
    }
    '/_authenticated/orgs/$orgId/groups': {
      id: '/_authenticated/orgs/$orgId/groups'
      path: '/groups'
      fullPath: '/orgs/$orgId/groups'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdGroupsRouteRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdRouteRoute
    }
    '/_authenticated/orgs/$orgId/groups/': {
      id: '/_authenticated/orgs/$orgId/groups/'
      path: '/'
      fullPath: '/orgs/$orgId/groups/'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdGroupsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdGroupsRouteRoute
    }
    '/_authenticated/orgs/$orgId/groups/$groupId': {
      id: '/_authenticated/orgs/$orgId/groups/$groupId'
      path: '/$groupId'
      fullPath: '/orgs/$orgId/groups/$groupId'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdGroupsGroupIdRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdGroupsRouteRoute
    }
    '/_authenticated/orgs/$orgId_/projects/$projectId': {
      id: '/_authenticated/orgs/$orgId_/projects/$projectId'
      path: '/$projectId'
      fullPath: '/orgs/$orgId/projects/$projectId'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectIdRouteRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdProjectsRouteRoute
    }
    '/_authenticated/orgs/$orgId_/projects/$projectId/': {
      id: '/_authenticated/orgs/$orgId_/projects/$projectId/'
      path: '/'
      fullPath: '/orgs/$orgId/projects/$projectId/'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectIdRouteRoute
    }
    '/_authenticated/orgs/$orgId_/projects/$projectId/tasks': {
      id: '/_authenticated/orgs/$orgId_/projects/$projectId/tasks'
      path: '/tasks'
      fullPath: '/orgs/$orgId/projects/$projectId/tasks'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectIdTasksRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectIdRouteRoute
    }
    '/_authenticated/orgs/$orgId_/projects/$projectId/permissions': {
      id: '/_authenticated/orgs/$orgId_/projects/$projectId/permissions'
      path: '/permissions'
      fullPath: '/orgs/$orgId/projects/$projectId/permissions'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectIdPermissionsRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectIdRouteRoute
    }
    '/_authenticated/orgs/$orgId_/projects/$projectId/integrations': {
      id: '/_authenticated/orgs/$orgId_/projects/$projectId/integrations'
      path: '/integrations'
      fullPath: '/orgs/$orgId/projects/$projectId/integrations'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectIdIntegrationsRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectIdRouteRoute
    }
    '/_authenticated/orgs/$orgId_/projects/$projectId/asset-sets': {
      id: '/_authenticated/orgs/$orgId_/projects/$projectId/asset-sets'
      path: '/asset-sets'
      fullPath: '/orgs/$orgId/projects/$projectId/asset-sets'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectIdAssetSetsRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectIdRouteRoute
    }
    '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless': {
      id: '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless'
      path: '/$projectId'
      fullPath: '/orgs/$orgId/projects/$projectId'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdProjectsRouteRoute
    }
    '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/compare': {
      id: '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/compare'
      path: '/compare'
      fullPath: '/orgs/$orgId/projects/$projectId/compare'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute
    }
    '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/tasks/tasks': {
      id: '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/tasks/tasks'
      path: '/tasks/tasks'
      fullPath: '/orgs/$orgId/projects/$projectId/tasks/tasks'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksTasksRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute
    }
    '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/tasks/create': {
      id: '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/tasks/create'
      path: '/tasks/create'
      fullPath: '/orgs/$orgId/projects/$projectId/tasks/create'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksCreateRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute
    }
    '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/compare_/$compareType': {
      id: '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/compare_/$compareType'
      path: '/compare/$compareType'
      fullPath: '/orgs/$orgId/projects/$projectId/compare/$compareType'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareCompareTypeRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute
    }
    '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/create': {
      id: '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/create'
      path: '/asset-sets/create'
      fullPath: '/orgs/$orgId/projects/$projectId/asset-sets/create'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsCreateRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute
    }
    '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId': {
      id: '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId'
      path: '/asset-sets/$assetSetId'
      fullPath: '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute
    }
    '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_/model': {
      id: '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_/model'
      path: '/asset-sets/$assetSetId/model'
      fullPath: '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/model'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdModelRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute
    }
    '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_/map-advanced': {
      id: '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_/map-advanced'
      path: '/asset-sets/$assetSetId/map-advanced'
      fullPath: '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/map-advanced'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdMapAdvancedRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute
    }
    '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_/annotate': {
      id: '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_/annotate'
      path: '/asset-sets/$assetSetId/annotate'
      fullPath: '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/annotate'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAnnotateRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute
    }
    '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_/assets_/$assetId_/map': {
      id: '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_/assets_/$assetId_/map'
      path: '/asset-sets/$assetSetId/assets/$assetId/map'
      fullPath: '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/assets/$assetId/map'
      preLoaderRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAssetsAssetIdMapRouteImport
      parentRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute
    }
  }
}

interface AuthenticatedOrgsOrgIdGroupsRouteRouteChildren {
  AuthenticatedOrgsOrgIdGroupsGroupIdRoute: typeof AuthenticatedOrgsOrgIdGroupsGroupIdRoute
  AuthenticatedOrgsOrgIdGroupsIndexRoute: typeof AuthenticatedOrgsOrgIdGroupsIndexRoute
}

const AuthenticatedOrgsOrgIdGroupsRouteRouteChildren: AuthenticatedOrgsOrgIdGroupsRouteRouteChildren =
  {
    AuthenticatedOrgsOrgIdGroupsGroupIdRoute:
      AuthenticatedOrgsOrgIdGroupsGroupIdRoute,
    AuthenticatedOrgsOrgIdGroupsIndexRoute:
      AuthenticatedOrgsOrgIdGroupsIndexRoute,
  }

const AuthenticatedOrgsOrgIdGroupsRouteRouteWithChildren =
  AuthenticatedOrgsOrgIdGroupsRouteRoute._addFileChildren(
    AuthenticatedOrgsOrgIdGroupsRouteRouteChildren,
  )

interface AuthenticatedOrgsOrgIdRouteRouteChildren {
  AuthenticatedOrgsOrgIdGroupsRouteRoute: typeof AuthenticatedOrgsOrgIdGroupsRouteRouteWithChildren
  AuthenticatedOrgsOrgIdBillingRoute: typeof AuthenticatedOrgsOrgIdBillingRoute
  AuthenticatedOrgsOrgIdMembersRoute: typeof AuthenticatedOrgsOrgIdMembersRoute
  AuthenticatedOrgsOrgIdPermissionsRoute: typeof AuthenticatedOrgsOrgIdPermissionsRoute
  AuthenticatedOrgsOrgIdProjectsRoute: typeof AuthenticatedOrgsOrgIdProjectsRoute
  AuthenticatedOrgsOrgIdSettingsRoute: typeof AuthenticatedOrgsOrgIdSettingsRoute
  AuthenticatedOrgsOrgIdIndexRoute: typeof AuthenticatedOrgsOrgIdIndexRoute
}

const AuthenticatedOrgsOrgIdRouteRouteChildren: AuthenticatedOrgsOrgIdRouteRouteChildren =
  {
    AuthenticatedOrgsOrgIdGroupsRouteRoute:
      AuthenticatedOrgsOrgIdGroupsRouteRouteWithChildren,
    AuthenticatedOrgsOrgIdBillingRoute: AuthenticatedOrgsOrgIdBillingRoute,
    AuthenticatedOrgsOrgIdMembersRoute: AuthenticatedOrgsOrgIdMembersRoute,
    AuthenticatedOrgsOrgIdPermissionsRoute:
      AuthenticatedOrgsOrgIdPermissionsRoute,
    AuthenticatedOrgsOrgIdProjectsRoute: AuthenticatedOrgsOrgIdProjectsRoute,
    AuthenticatedOrgsOrgIdSettingsRoute: AuthenticatedOrgsOrgIdSettingsRoute,
    AuthenticatedOrgsOrgIdIndexRoute: AuthenticatedOrgsOrgIdIndexRoute,
  }

const AuthenticatedOrgsOrgIdRouteRouteWithChildren =
  AuthenticatedOrgsOrgIdRouteRoute._addFileChildren(
    AuthenticatedOrgsOrgIdRouteRouteChildren,
  )

interface AuthenticatedOrgsOrgIdProjectsProjectIdRouteRouteChildren {
  AuthenticatedOrgsOrgIdProjectsProjectIdAssetSetsRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectIdAssetSetsRoute
  AuthenticatedOrgsOrgIdProjectsProjectIdIntegrationsRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectIdIntegrationsRoute
  AuthenticatedOrgsOrgIdProjectsProjectIdPermissionsRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectIdPermissionsRoute
  AuthenticatedOrgsOrgIdProjectsProjectIdTasksRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectIdTasksRoute
  AuthenticatedOrgsOrgIdProjectsProjectIdIndexRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectIdIndexRoute
}

const AuthenticatedOrgsOrgIdProjectsProjectIdRouteRouteChildren: AuthenticatedOrgsOrgIdProjectsProjectIdRouteRouteChildren =
  {
    AuthenticatedOrgsOrgIdProjectsProjectIdAssetSetsRoute:
      AuthenticatedOrgsOrgIdProjectsProjectIdAssetSetsRoute,
    AuthenticatedOrgsOrgIdProjectsProjectIdIntegrationsRoute:
      AuthenticatedOrgsOrgIdProjectsProjectIdIntegrationsRoute,
    AuthenticatedOrgsOrgIdProjectsProjectIdPermissionsRoute:
      AuthenticatedOrgsOrgIdProjectsProjectIdPermissionsRoute,
    AuthenticatedOrgsOrgIdProjectsProjectIdTasksRoute:
      AuthenticatedOrgsOrgIdProjectsProjectIdTasksRoute,
    AuthenticatedOrgsOrgIdProjectsProjectIdIndexRoute:
      AuthenticatedOrgsOrgIdProjectsProjectIdIndexRoute,
  }

const AuthenticatedOrgsOrgIdProjectsProjectIdRouteRouteWithChildren =
  AuthenticatedOrgsOrgIdProjectsProjectIdRouteRoute._addFileChildren(
    AuthenticatedOrgsOrgIdProjectsProjectIdRouteRouteChildren,
  )

interface AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRouteChildren {
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareRoute
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdRoute
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsCreateRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsCreateRoute
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareCompareTypeRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareCompareTypeRoute
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksCreateRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksCreateRoute
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksTasksRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksTasksRoute
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAnnotateRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAnnotateRoute
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdMapAdvancedRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdMapAdvancedRoute
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdModelRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdModelRoute
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAssetsAssetIdMapRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAssetsAssetIdMapRoute
}

const AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRouteChildren: AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRouteChildren =
  {
    AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareRoute:
      AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareRoute,
    AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdRoute:
      AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdRoute,
    AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsCreateRoute:
      AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsCreateRoute,
    AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareCompareTypeRoute:
      AuthenticatedOrgsOrgIdProjectsProjectId_pathlessCompareCompareTypeRoute,
    AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksCreateRoute:
      AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksCreateRoute,
    AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksTasksRoute:
      AuthenticatedOrgsOrgIdProjectsProjectId_pathlessTasksTasksRoute,
    AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAnnotateRoute:
      AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAnnotateRoute,
    AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdMapAdvancedRoute:
      AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdMapAdvancedRoute,
    AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdModelRoute:
      AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdModelRoute,
    AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAssetsAssetIdMapRoute:
      AuthenticatedOrgsOrgIdProjectsProjectId_pathlessAssetSetsAssetSetIdAssetsAssetIdMapRoute,
  }

const AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRouteWithChildren =
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute._addFileChildren(
    AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRouteChildren,
  )

interface AuthenticatedOrgsOrgIdProjectsRouteRouteChildren {
  AuthenticatedOrgsOrgIdProjectsProjectIdRouteRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectIdRouteRouteWithChildren
  AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute: typeof AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRouteWithChildren
}

const AuthenticatedOrgsOrgIdProjectsRouteRouteChildren: AuthenticatedOrgsOrgIdProjectsRouteRouteChildren =
  {
    AuthenticatedOrgsOrgIdProjectsProjectIdRouteRoute:
      AuthenticatedOrgsOrgIdProjectsProjectIdRouteRouteWithChildren,
    AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRoute:
      AuthenticatedOrgsOrgIdProjectsProjectId_pathlessRouteRouteWithChildren,
  }

const AuthenticatedOrgsOrgIdProjectsRouteRouteWithChildren =
  AuthenticatedOrgsOrgIdProjectsRouteRoute._addFileChildren(
    AuthenticatedOrgsOrgIdProjectsRouteRouteChildren,
  )

interface AuthenticatedOrgsRouteRouteChildren {
  AuthenticatedOrgsOrgIdRouteRoute: typeof AuthenticatedOrgsOrgIdRouteRouteWithChildren
  AuthenticatedOrgsIndexRoute: typeof AuthenticatedOrgsIndexRoute
  AuthenticatedOrgsOrgIdProjectsRouteRoute: typeof AuthenticatedOrgsOrgIdProjectsRouteRouteWithChildren
}

const AuthenticatedOrgsRouteRouteChildren: AuthenticatedOrgsRouteRouteChildren =
  {
    AuthenticatedOrgsOrgIdRouteRoute:
      AuthenticatedOrgsOrgIdRouteRouteWithChildren,
    AuthenticatedOrgsIndexRoute: AuthenticatedOrgsIndexRoute,
    AuthenticatedOrgsOrgIdProjectsRouteRoute:
      AuthenticatedOrgsOrgIdProjectsRouteRouteWithChildren,
  }

const AuthenticatedOrgsRouteRouteWithChildren =
  AuthenticatedOrgsRouteRoute._addFileChildren(
    AuthenticatedOrgsRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedOrgsRouteRoute: typeof AuthenticatedOrgsRouteRouteWithChildren
  AuthenticatedDashRoute: typeof AuthenticatedDashRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedBillingCheckoutReturnRoute: typeof AuthenticatedBillingCheckoutReturnRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedOrgsRouteRoute: AuthenticatedOrgsRouteRouteWithChildren,
  AuthenticatedDashRoute: AuthenticatedDashRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedBillingCheckoutReturnRoute:
    AuthenticatedBillingCheckoutReturnRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface UnauthenticatedRouteChildren {
  UnauthenticatedConfirmSignupRoute: typeof UnauthenticatedConfirmSignupRoute
  UnauthenticatedForgotPasswordRoute: typeof UnauthenticatedForgotPasswordRoute
  UnauthenticatedLoginRoute: typeof UnauthenticatedLoginRoute
  UnauthenticatedSignupRoute: typeof UnauthenticatedSignupRoute
}

const UnauthenticatedRouteChildren: UnauthenticatedRouteChildren = {
  UnauthenticatedConfirmSignupRoute: UnauthenticatedConfirmSignupRoute,
  UnauthenticatedForgotPasswordRoute: UnauthenticatedForgotPasswordRoute,
  UnauthenticatedLoginRoute: UnauthenticatedLoginRoute,
  UnauthenticatedSignupRoute: UnauthenticatedSignupRoute,
}

const UnauthenticatedRouteWithChildren = UnauthenticatedRoute._addFileChildren(
  UnauthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  SplatRoute: SplatRoute,
  R404Route: R404Route,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  UnauthenticatedRoute: UnauthenticatedRouteWithChildren,
  SupportSessionRoute: SupportSessionRoute,
  ShareTokenRoute: ShareTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
